import { UserPermissionCodes } from "@odata/CompanyPermissionEnums";
import { WithOData, withOData } from "@odata/withOData";
import {
    getChatForAgendaTile,
    getEstimatedAccrualsDef,
    getFutureExpensesAndRevenuesDef,
    getInboxTileDef
} from "@pages/home/Home.utils";
import { isCashBasisAccountingCompany, isOnOrganizationLevel } from "@utils/CompanyUtils";
import React, { memo, useContext } from "react";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../../contexts/appContext/AppContext.types";
import { ROUTE_AGENDA_WORK_OVERVIEW } from "../../../routes";
import { IDashboardTileComponentProps } from "../../dashboard";
import DashboardTileHeader from "../../dashboard/DashboardTileHeader";
import InfoTile from "../infoTile";
import {
    GroupedInfoTileBackground,
    GroupedInfoTileContentWrapper,
    GroupInfoTileHeader
} from "../infoTile/InfoTile.styles";

interface IProps extends IDashboardTileComponentProps, WithOData {
}

const AgendaWorkOverview: React.FC<IProps> = ({ inEditMode }) => {
    const { t } = useTranslation("Home");
    const context = useContext(AppContext);
    const futureExpensesAndRevenuesInfo = getFutureExpensesAndRevenuesDef(true);
    const estimatedAccrualsInfo = getEstimatedAccrualsDef(true);
    const inboxInfo = getInboxTileDef(true);
    const chatInfo = getChatForAgendaTile(true);
    const isCrossCompany = isOnOrganizationLevel({ context });

    const showInternalDocRelated = isCrossCompany || context.getCompanyPermissions().has(UserPermissionCodes.InternalDocuments);
    const showInboxRelated = isCrossCompany || context.getCompanyPermissions().has(UserPermissionCodes.InBox);
    const isCashBasis = isCashBasisAccountingCompany(context);
    const cols = isCashBasis ? 1 : 2;

    return (
            <GroupedInfoTileBackground
                    inEditMode={inEditMode}
                    overflowed
                    to={isCrossCompany ? ROUTE_AGENDA_WORK_OVERVIEW : undefined}>
                <GroupInfoTileHeader>
                    <DashboardTileHeader>{t(`Home:AgendaWorkOverview.${isCrossCompany ? "Title" : "SingleCompanyTitle"}`)}</DashboardTileHeader>
                </GroupInfoTileHeader>

                <GroupedInfoTileContentWrapper cols={cols} rows={2}>
                    {!isCashBasis &&
                        <>
                            {showInternalDocRelated &&
                                <InfoTile inEditMode={inEditMode} info={futureExpensesAndRevenuesInfo} isGrouped/>}
                            {showInternalDocRelated &&
                                <InfoTile inEditMode={inEditMode} info={estimatedAccrualsInfo} isGrouped/>}
                        </>
                    }
                    {showInboxRelated && <InfoTile inEditMode={inEditMode} info={inboxInfo} isGrouped/>}
                    <InfoTile inEditMode={inEditMode} info={chatInfo} isGrouped/>
                </GroupedInfoTileContentWrapper>
            </GroupedInfoTileBackground>
    );
};

export default memo(withOData(AgendaWorkOverview));